/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updateyourbusinessnameanddescription5Inputs */

const en_updateyourbusinessnameanddescription5 = /** @type {(inputs: Updateyourbusinessnameanddescription5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your business name and description`)
};

const de_updateyourbusinessnameanddescription5 = /** @type {(inputs: Updateyourbusinessnameanddescription5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändere Namen und Beschreibung deines Unternehmens.`)
};

/**
* | output |
* | --- |
* | "Update your business name and description" |
*
* @param {Updateyourbusinessnameanddescription5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const updateyourbusinessnameanddescription5 = /** @type {((inputs?: Updateyourbusinessnameanddescription5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updateyourbusinessnameanddescription5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_updateyourbusinessnameanddescription5(inputs)
	return de_updateyourbusinessnameanddescription5(inputs)
});
export { updateyourbusinessnameanddescription5 as "updateYourBusinessNameAndDescription" }